module.exports = __webpack_public_path__ + "img/prefill-icon.009eaf11.svg";